<template>
  <div class="row" style="margin: 0;">
    <div class="col-md-6">
      <div class="row" style="margin: 0; align-items: end; margin-top: 5px;">
        <div class="form-group col-md-6">
          <label for="operarios">Operarios:</label>
          <select v-model="operarioseleccionado" class="form-control" id="operarios">
            <option value="-1">Seleccione operario</option>
            <option value="">Todos</option>
            <option v-for="operario in operarios" :key="operario.id" :style="operario.cobertura?'color: green;':''" :value="operario.id">{{ operario.nombre }}</option>
          </select>
        </div>
        <div class="form-group col-md-2">
          <label for="operarios">Guardia:</label>
          <select v-model="tiposeleccionado" class="form-control" id="tipos">
            <option value="">Todas</option>
            <option value="1">Mostrar solo guardias</option>
            <option value="0">Ocultar guardias</option>
          </select>
        </div>
        <div class="col-md-4 form-group">
          <label for="operarios">Especialidad:</label>
          <select :disabled="this.operarioseleccionado!=''" v-model="especialidadseleccionada" class="form-control" id="especialidades">
            <option value="">Todas</option>
            <option v-for="especialidad in especialdiades" :key="especialidad.id" :value="especialidad.id">{{ especialidad.nombre }}</option>
          </select>
        </div>
      </div>
      <div class="table-responsive" style="height: 600px;">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Operario</th>
              <th>Nombre</th>
              <th>Kms</th>
              <th>Guardia</th>
              <th>Editar</th>
              <th>Eliminar</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="cobertura in coberturas" :key="cobertura.id">
              <th>{{ cobertura.nombre }}</th>
              <th>{{ cobertura.nombre_cobertura }}</th>
              <th>{{ cobertura.kilometros_cobetura }}</th>
              <th><input @click="cambiarGuardia(cobertura)" type="checkbox" v-model="cobertura.guardia" v-bind:true-value="1" v-bind:false-value="0"></th>
              <th>
                <button class="btn btn-sm btn-info" title="Editar" @click="abrirModalCobertura(cobertura)"><i class="fas fa-edit"></i></button>            
              </th>
              <th>
                <button class="btn btn-sm btn-danger" title="Eliminar" @click="eliminarCobertura(cobertura.id)"><i class="fas fa-times"></i></button>            
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-md-6">
      <div id="map" style="height: 100%;"></div>
    </div>
  </div>
  <Dialog v-model:visible="mostrarModalCobertura" header="Editar cobertura" :modal="true" :style="{ width: '30rem' }">
      <div class="form-group">
          <label for="nombre_cobertura">Nombre</label>
          <input id="nombre_cobertura" type="text" class="form-control"
              v-model="coberturaEditando.nombre" @keyup.enter="guardarCobertura()">
      </div>
      <template #footer>
          <button class="btn btn-secondary" @click="mostrarModalCobertura = false">Cancelar</button>
          <button class="btn btn-primary" @click="guardarCobertura()" :disabled="guardandoCobertura">Guardar</button>
      </template>
  </Dialog>
</template>

<script>
import { PwgsApi } from '../../../../services/PwgsApi';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';
import Dialog from 'primevue/dialog';

export default({
  props: ['id_operario'],
  components: {Dialog},
  data() {
    return {
      coordenadas_empresa: [],
      coordenadas_iniciales:[],
      operarios: [],
      operarioseleccionado: '-1',
      tiposeleccionado: '',
      especialdiades: [],
      especialidadseleccionada: '',
      map: null,
      drawControl: null,
      drawnItems: null,
      coberturas: [], // Aquí se almacenarán las coberturas que recibas,
      mostrarModalCobertura: false,
      coberturaEditando: {id: null, nombre: ''},
      guardandoCobertura: false
    }
  },
  methods: {
    async cambiarGuardia(cobertura){
      const api = new PwgsApi();
      try{
        await api.put('coberturas-operarios/'+cobertura.id,{guardia: cobertura.guardia!=1?'true':'false'});
        this.cargarCoberturas();
      }catch(e){
        this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
      }
    },
    async eliminarCobertura(idcobertura){
      const api = new PwgsApi();
      await api.delete('/coberturas-operarios/'+idcobertura);
      this.cargarCoberturas();
      this.$emit('actualizarGuardias');
    },
    abrirModalCobertura(cobertura) {
      console.log(cobertura);
      
			this.coberturaEditando = { id: cobertura.id_cobertura, nombre: cobertura.nombre_cobertura };
			this.mostrarModalCobertura = true;
		},
		async guardarCobertura() {
			const nombre = this.coberturaEditando.nombre.trim();
			if (!nombre) {
				this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El nombre no puede estar vacío', life: 5000 });
				return;
			}
			this.guardandoCobertura = true;
			try {
				const api = new PwgsApi();
				await api.put('/coberturas-operarios/' + this.coberturaEditando.id, { nombre_cobertura: nombre });
				this.mostrarModalCobertura = false;
        this.cargarCoberturas();
				this.$emit('actualizarGuardias');
				this.$toast.add({ severity: 'success', summary: 'Actualizado', detail: 'Nombre cobertura actualizado correctamente', life: 5000 });
			} catch (error) {
				this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
			} finally {
				this.guardandoCobertura = false;
			}
		},
    cargarMapa() {
      if (!this.map) {
        const opciones = { zoomSnap: 0.5, zoomDelta: 0.5 };
        if (this.coordenadas_iniciales.length == 0){
          this.map = L.map('map', opciones).setView([parseFloat(this.coordenadas_empresa[0]), parseFloat(this.coordenadas_empresa[1])], 10);
        }else{
          this.map = L.map('map', opciones).setView(this.coordenadas_iniciales, 10);
        }

        const capaOsm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        });
        const capaIgn = L.tileLayer.wms('https://www.ign.es/wms-inspire/ign-base', {
          layers: 'IGNBaseTodo', format: 'image/png', transparent: false,
          attribution: '&copy; <a href="https://www.ign.es">Instituto Geográfico Nacional</a>'
        });

        capaOsm.addTo(this.map);   // capa por defecto

        const capaLimites = L.tileLayer.wms('https://www.ign.es/wms-inspire/unidades-administrativas', {
          layers: 'AU.AdministrativeBoundary', styles: 'LimitesCruz',
          format: 'image/png', transparent: true, opacity: 0.8,
          attribution: '&copy; <a href="https://www.ign.es">Instituto Geográfico Nacional</a>'
        });

        capaLimites.addTo(this.map);   // límites marcados por defecto

        L.control.layers(
          { 'Mapa de calles': capaOsm, 'Cartografía oficial (IGN)': capaIgn},
          { 'Límites administrativos': capaLimites },
          { position: 'topright' }
        ).addTo(this.map);

        this.drawnItems = new L.FeatureGroup();
        this.map.addLayer(this.drawnItems);
        this.map.on(L.Draw.Event.CREATED, async (event) => {
        const layer = event.layer;
        this.drawnItems.addLayer(layer);
        let tipo = '';
        let data = {};
        if (layer instanceof L.Circle) {
          // Si es un círculo
          tipo = 'circular';
          const latlng = layer.getLatLng();
          const radius = layer.getRadius();
          
          // Crear el cuerpo del POST para un círculo
          data = {
            tipo: tipo,
            nombre: "Cobertura circular "+latlng.lat+','+latlng.lng, // Puedes cambiar este nombre o pedir que el usuario lo ingrese
            id_operario: this.operarioseleccionado, // Operario seleccionado
            radio: radius / 1000, // Convertimos a kilómetros si lo necesitas
            latitud: latlng.lat,
            longitud: latlng.lng,            
          };
          if(this.tiposeleccionado==1)data.guardia=1;

        } else if (layer instanceof L.Polygon) {
          // Si es un polígono
          tipo = 'poligonal';
          const latlngs = layer.getLatLngs()[0]; // Obtenemos las coordenadas del polígono

          // Convertimos las coordenadas a un array de strings "lat,lng"
          const poligono = latlngs.map(latlng => `${latlng.lat},${latlng.lng}`);
          const fecha = Date.now();
          const hoy = new Date(fecha);
          // Crear el cuerpo del POST para un polígono
          data = {
            tipo: tipo,
            nombre: "Cobertura poligonal "+hoy.toLocaleDateString(), // Puedes cambiar este nombre o pedir que el usuario lo ingrese
            id_operario: this.operarioseleccionado, // Operario seleccionado
            poligono: poligono,            
          };
          if(this.tiposeleccionado==1)data.guardia=1;
        }

        // Realizamos la solicitud POST
        if (data.tipo) {
          try {
            const api = new PwgsApi();
            await api.post('/coberturas-operarios', data);

            // Recargar las coberturas después de crear una nueva
            this.$emit('actualizarGuardias');
            this.cargarCoberturas();
          } catch (error) {
            console.error('Error al crear la cobertura:', error);
          }
        }
      });
      }
      this.actualizarControlesDeDibujo();
      this.mostrarCoberturas();
    },
    actualizarControlesDeDibujo() {
      if (this.drawControl) {
        this.map.removeControl(this.drawControl);
      }

      this.drawControl = new L.Control.Draw({
        edit: {
          featureGroup: this.drawnItems,
          remove: false,
          edit:false
        },
        draw: {
          polyline: false,
          rectangle: false,
          marker: false,
          circlemarker: false,
          polygon: this.operarioseleccionado > 0,
          circle: this.operarioseleccionado > 0
        }
      });

      this.map.addControl(this.drawControl);
    },
    mostrarCoberturas() {
      this.drawnItems.clearLayers(); // Limpiar cualquier forma existente
      if(this.coberturas == []){
        return;
      }
      this.coberturas.forEach(cobertura => {
        var color = 'blue';
        if(cobertura.guardia == 1){
          color = 'red';
        }
        if (cobertura.tipo_cobertura === 'circular') {
          const lat = parseFloat(cobertura.latitud_cobertura);
          const lng = parseFloat(cobertura.longitud_cobetura);
          const radius = parseFloat(cobertura.kilometros_cobetura) * 1000; // Convertir kilómetros a metros

          // Validar las coordenadas antes de crear el círculo
          if (!isNaN(lat) && !isNaN(lng) && !isNaN(radius)) {
            const circle = L.circle([lat, lng], {
              radius: radius,
              color: color,  // Color del borde
              fillColor: color,  // Color de relleno
              fillOpacity: 0.1,  // Opacidad del relleno (0.0 a 1.0)
              opacity: 0.5  // Opacidad del borde (0.0 a 1.0)
            });
            this.drawnItems.addLayer(circle);
          } else {
            console.error('Coordenadas inválidas para cobertura circular:', cobertura);
          }
        } else if (cobertura.tipo_cobertura === 'poligonal') {
          const latLngs = cobertura.poligono_cobertura.split(';').map(coord => {
            const [lat, lng] = coord.split(',').map(Number);
            return (!isNaN(lat) && !isNaN(lng)) ? [lat, lng] : null;
          }).filter(Boolean); // Filtrar valores nulos o inválidos

          if (latLngs.length > 0) {
            const polygon = L.polygon(latLngs, {
              color: color,  // Color del borde
              fillColor: color,  // Color de relleno
              fillOpacity: 0.1,  // Opacidad del relleno (0.0 a 1.0)
              opacity: 0.5  // Opacidad del borde (0.0 a 1.0)
            });
            this.drawnItems.addLayer(polygon);
          } else {
            console.error('Coordenadas inválidas para cobertura poligonal:', cobertura);
          }
        }
      });
    },
    async cargarOperarios() {
      const api = new PwgsApi();
      const res = await api.get('coberturas-operarios');
      this.operarios = res.datos;
    },
    async cargarEspecialidades() {
      const api = new PwgsApi();
      const res = await api.get('especialidades');
      this.especialdiades = res.datos;
    },
    async cargarCoberturas() {
      const api = new PwgsApi();
      const datos = await api.get('empresa');
      this.coordenadas_empresa = datos.datos.coordenadas_empresa.split(',');
      if(this.operarioseleccionado != -1){
        var body ={id_operario:this.operarioseleccionado, id_especialidad:this.especialidadseleccionada};
        if(this.tiposeleccionado)body.guardia=this.tiposeleccionado;
        const res = await api.post('coberturas-operarios/coberturas', body);
        this.coordenadas_iniciales = res.coordenadas;
        this.coberturas = res.coberturas.datos;        
      }
      else{
        this.coberturas = [];
      }
      if(this.coberturas != []){
        this.coberturas.sort((a, b) => {
          if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
            return -1;
          }
          if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
            return 1;
          }
          return 0;
        });
      }
      this.cargarMapa();
    }
  },
  mounted() {
    this.cargarCoberturas(); // Cargar y mostrar las coberturas existentes    
    this.cargarOperarios();
    this.cargarEspecialidades();
  },
  watch: {
    id_operario: {
      immediate: true,
      handler(newValue) {
        this.operarioseleccionado = newValue;
        console.log('llegaoperario', this.operarioseleccionado);
      }
    },
    operarioseleccionado(newValue) {
      if(newValue!='')this.especialidadseleccionada='';
      this.cargarCoberturas();
    },
    especialidadseleccionada(){
      this.cargarCoberturas();
    },
    tiposeleccionado(){
      this.cargarCoberturas();
    }
  }
});
</script>

<style>
#map { height: 500px; }
</style>
